
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import cn from "classnames";
import styles from "./Site.module.scss";
import Analytics from "../../components/sitecomponent/Analytics";
import Layout from "../../components/sitecomponent/Layout";
import SiteInformation from "./SiteInformation";
import { Link } from "react-router-dom";
import Master from "screen/Master";
import { useHistory, Redirect } from "react-router-dom";
let multiselectArray = [];

function SiteView(props) {
  //

  const [filterData, setChargerMultiSelecct] = useState(multiselectArray);
  const [page, setPage] = useState(0);

  const search = useLocation().search;
  // id = props.match.params.id;
  const siteId = props.match.params.id;
  const name = props.match.params.name;
  const enterprise = props.match.params.enterpriseName;
  const view = props.match.params.view;
  const history = useHistory();

  useEffect(() => {
    localStorage.setItem("activeTabCount", "zoneAsset");
    if (view == 0) {
      setPage(0);
    } else if (view == 1) {
      setPage(1);
    } else if (view == 2) {
      setPage(2);
    }
  }, []);

  return (
    <>
      <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
        {name}
      </h2>

      <div className={cn(styles.flex1, styles.flex1_layout2)}>
        <div
          className={cn(styles.flex_item)}
          style={page === 0 ? { textDecoration: "none" } : {}}
        >
          <h3
            className={
              page === 0
                ? cn(
                    styles.subtitle_highlight,
                    styles.subtitle_highlight_layout
                  )
                : cn(styles.subtitle_text, styles.subtitle_text_layout)
            }
            onClick={() => {
              setPage(0);
              // history.push(`sites/site/${siteId}/${name}/${enterprise}/0`);
              history.push(`0`);
              //window.location.reload();
              ///sites/site/:id/:name/:enterpriseName/:view
            }}
          >
            {"Analytics"}
          </h3>
        </div>
        <div className={cn(styles.flexspace_spacer2)} />

        <div
          className={cn(styles.flexspace_item)}
          style={page === 1 ? { textDecoration: "none" } : {}}
        >
          <h3
            className={
              page === 1
                ? cn(
                    styles.subtitle_highlight,
                    styles.subtitle_highlight_layout
                  )
                : cn(styles.subtitle_text, styles.subtitle_text_layout)
            }
            onClick={() => {
              // history.push(`sites/site/${siteId}/${name}/${enterprise}/1`);
              history.push(`1`);
              setPage(1);
            }}
          >
            {"Site Information"}
          </h3>
        </div>

        <div className={cn(styles.flex6_spacer)} />
        <div
          className={cn(styles.block45_item1)}
          style={page === 2 ? { textDecoration: "none" } : {}}
        >
          <h3
            className={
              page === 2
                ? cn(
                    styles.subtitle_highlight,
                    styles.subtitle_highlight_layout
                  )
                : cn(styles.subtitle_text, styles.subtitle_text_layout)
            }
            onClick={() => {
              // history.push(`sites/site/${siteId}/${name}/${enterprise}/2`);
              history.push(`2`);
              setPage(2);
            }}
          >
            {"Site Layout"}
          </h3>
        </div>
      </div>

      <div
        className={cn(styles.card_list_block, styles.card_list_block_layout)}
      >
        {page === 0 ? (
          <Analytics siteId={siteId}></Analytics>
        ) : page === 1 ? (
          <SiteInformation
            siteId={siteId}
            enterprise={enterprise}
          ></SiteInformation>
        ) : (
          <Layout siteId={siteId} enterprise={enterprise}></Layout>
        )}
      </div>
    </>
  );
}

export default function Site(props) {
  const siteId = props.match.params.id;
  const name = props.match.params.name;
  const enterpriseName = props.match.params.enterpriseName;
  let Urls = window.location.href.toString().split(window.location.host)[1];
  console.log("----", Urls, siteId, name);
  return (
    <>
      <Master
        sitesName={Urls}
        opts={props}
        screen={SiteView}
        showStatus={true}
        UrlSiteData={siteId}
        siteNameURL={name}
        enterpriseNameURL={enterpriseName}
      />
    </>
  );
}

Site.inStorybook = true;
